import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';

import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { CardTitle } from '../../components/CardTitle';
import { assetPathFn } from '../../util';
import { useLanderControls } from '../LanderContext';

export const LeggingTwoLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-legging-two-lander-top-hero-1.jpg'} title={'Legging 2.0'} subTitle={'Next-level sculpting meets elevated design.'}>
          <HeroCallout
            orderIndex={1}
            titleStyles={{ textAlign: 'right', lineHeight: '22px' }}
            label={
              <>
                Wide, supportive <br />
                waistband
              </>
            }
            inlineStyles={{
              mobile: {
                left: `2.8%`,
                top: `38.5%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={0}
            label={'Sheer-proof fabric'}
            inlineStyles={{
              mobile: {
                left: `52%`,
                top: `44%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={'Deep, invisible pockets'}
            inlineStyles={{
              mobile: {
                left: `41%`,
                top: `52%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-leggingtwo-desktop-1.jpg',
              title: 'Hidden shaping',
              description: 'Lower tummy and thigh shaping panels secretly sculpt your body.',
            },
            {
              imgName: 'feature-leggingtwo-desktop-2.jpg',
              title: 'Stylish details',
              description: 'Tasteful stitching and bonded finishes give an upscale, tailored touch.',
            },
            {
              imgName: 'feature-leggingtwo-desktop-3.jpg',
              title: 'Soft and opaque',
              description: 'Bend over and stretch with confidence — luxe, opaque fabric is never sheer.',
            },
          ]}
        />
        <CardTitle
          text={
            <>
              The Honeylove <br />
              difference
            </>
          }
          style={{ fontSize: '18pt', fontWeight: '200', textTransform: 'unset' }}
        />
        <img src={assetPathFn('leggings-two-annotate-mobile.jpg')} alt="difference" />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.LeggingTwo]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default LeggingTwoLanderMobile;
